<template>
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="1.25" x2="16" y2="1.25" stroke="currentColor" stroke-width="1.5" />
    <line y1="7.25" x2="16" y2="7.25" stroke="currentColor" stroke-width="1.5" />
    <line y1="13.25" x2="16" y2="13.25" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
